import { render, staticRenderFns } from "./unicomDeal2.vue?vue&type=template&id=a4234408&scoped=true"
import script from "./unicomDeal2.vue?vue&type=script&lang=js"
export * from "./unicomDeal2.vue?vue&type=script&lang=js"
import style0 from "./unicomDeal2.vue?vue&type=style&index=0&id=a4234408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4234408",
  null
  
)

export default component.exports